export default "__VITE_ASSET__BmbgJ5N5__"